import { motion } from "framer-motion";
import { Trophy, Swords, Users } from "lucide-react";

const pillars = [
  {
    icon: Trophy,
    title: "Ranking Oficial",
    description:
      "Sistema de pontuação transparente. Cada competição vale pontos reais no ranking estadual.",
  },
  {
    icon: Swords,
    title: "Competições",
    description:
      "Calendário regulamentado com eventos oficiais, padrões técnicos e arbitragem qualificada.",
  },
  {
    icon: Users,
    title: "Desenvolvimento de Atletas",
    description:
      "Programas de capacitação, categorias por nível e suporte ao crescimento de cada federado.",
  },
];

export default function PositioningSection() {
  return (
    <section className="py-24 md:py-32 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-xs font-semibold uppercase tracking-[0.25em] text-primary mb-6 flex items-center gap-3"
          >
            <span className="w-8 h-px bg-primary" />
            Posicionamento
          </motion.p>

          {/* Manifesto */}
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl uppercase leading-[0.95] mb-16"
          >
            <span className="text-foreground">Não organizamos</span>{" "}
            <span className="text-foreground/50">eventos.</span>
            <br />
            <span className="text-foreground">Formamos</span>{" "}
            <span className="text-primary">atletas.</span>
          </motion.h2>

          {/* Pillars */}
          <div className="grid sm:grid-cols-3 gap-8 md:gap-12">
            {pillars.map((pillar, i) => {
              const Icon = pillar.icon;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.15, duration: 0.5 }}
                  className="group"
                >
                  <div className="w-12 h-12 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center mb-5 group-hover:bg-primary/20 transition-colors">
                    <Icon size={22} className="text-primary" />
                  </div>
                  <h3 className="font-bold text-foreground text-lg mb-3">
                    {pillar.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {pillar.description}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
